import { useEffect, Dispatch, SetStateAction } from 'react';
import { rutiner } from '../../_Common/Const/Rutiner';
import useShowDetailsRightDisabledOnCurrentScreenSize from './useShowDetailsRightDisabledOnCurrentScreenSize';

const useForceShowDetailsRightDisabledOnScreenSize = (
  rutinKod: string,
  showDetailsRight: boolean,
  setShowDetailsRight: Dispatch<SetStateAction<boolean>>
): void => {
  const showDetailsRightDisabledOnCurrentScreenSize =
    useShowDetailsRightDisabledOnCurrentScreenSize();

  useEffect(() => {
    if (showDetailsRightDisabledOnCurrentScreenSize && showDetailsRight) {
      setShowDetailsRight(false);
    } else {
      const rutin = rutiner[rutinKod];
      if (
        !showDetailsRightDisabledOnCurrentScreenSize &&
        !showDetailsRight &&
        rutin &&
        rutin.defaultShowDetailsRight
      ) {
        setShowDetailsRight(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetailsRightDisabledOnCurrentScreenSize, rutinKod]);
};

export default useForceShowDetailsRightDisabledOnScreenSize;
